<kendo-dialog [width]="1120" [maxWidth]="'95vw'" [height]="'90vh'" (close)="closed.emit()">
    <kendo-dialog-titlebar>
        {{ "FLIGHT_LIST.edit.title" | translate }}
        @if (flight().registrationMark) {
            <strong class="aircraft">{{ flight().registrationMark }}</strong>
        }
    </kendo-dialog-titlebar>
    @if (ready()) {
        <kendo-tabstrip class="tabs" [keepTabContent]="true">
            <kendo-tabstrip-tab [title]="'FLIGHT_LIST.edit.tabs.flight' | translate" [selected]="true">
                <ng-template kendoTabContent>
                    <app-flight-tab [form]="form" [flight]="flight()" [lookups]="lookups"></app-flight-tab>
                </ng-template>
            </kendo-tabstrip-tab>

            <kendo-tabstrip-tab [title]="'FLIGHT_LIST.edit.tabs.crew' | translate">
                <ng-template kendoTabContent>
                    <app-crew-tab [form]="form" [lookups]="lookups" [members]="crewMembers"></app-crew-tab>
                </ng-template>
            </kendo-tabstrip-tab>

            <kendo-tabstrip-tab [title]="'FLIGHT_LIST.edit.tabs.engineData' | translate">
                <ng-template kendoTabContent>
                    <app-engine-data-tab [group]="form.controls.flight" [engines]="engines()"></app-engine-data-tab>
                </ng-template>
            </kendo-tabstrip-tab>

            <kendo-tabstrip-tab [title]="'FLIGHT_LIST.edit.tabs.refuel' | translate">
                <ng-template kendoTabContent>
                    <app-refuel-tab [rows]="form.controls.refuels" [units]="lookups.fuelUnits" [maxTank]="lookups.maxTank"></app-refuel-tab>
                </ng-template>
            </kendo-tabstrip-tab>

            <kendo-tabstrip-tab [title]="'FLIGHT_LIST.edit.tabs.oil' | translate">
                <ng-template kendoTabContent>
                    <app-oil-tab [rows]="form.controls.oils" [units]="lookups.oilUnits" [circuits]="oilCircuits()"></app-oil-tab>
                </ng-template>
            </kendo-tabstrip-tab>

            <!-- A tab for the hooks and one for the hoists, only for a flight that has them mounted. -->
            @if (hookLabels().length) {
                <kendo-tabstrip-tab [title]="'FLIGHT_LIST.edit.tabs.hooks' | translate">
                    <ng-template kendoTabContent>
                        <app-hook-tab [rows]="form.controls.hooks" [labels]="hookLabels()"></app-hook-tab>
                    </ng-template>
                </kendo-tabstrip-tab>
            }

            @if (hoistLabels().length) {
                <kendo-tabstrip-tab [title]="'FLIGHT_LIST.edit.tabs.hoists' | translate">
                    <ng-template kendoTabContent>
                        <app-hoist-tab [rows]="form.controls.hoists" [labels]="hoistLabels()"></app-hoist-tab>
                    </ng-template>
                </kendo-tabstrip-tab>
            }

            @if (configs().penaltyFactorEnabled) {
                <kendo-tabstrip-tab [title]="'FLIGHT_LIST.edit.tabs.penaltyFactor' | translate">
                    <ng-template kendoTabContent>
                        <app-penalty-factor-tab [group]="form.controls.penaltyFactor"></app-penalty-factor-tab>
                    </ng-template>
                </kendo-tabstrip-tab>
            }

            @if (configs().enginePowerCheckEnabled) {
                <kendo-tabstrip-tab [title]="'FLIGHT_LIST.edit.tabs.enginePowerCheck' | translate">
                    <ng-template kendoTabContent>
                        <app-engine-power-check-tab [group]="form.controls.enginePowerCheck" [engines]="engines()"></app-engine-power-check-tab>
                    </ng-template>
                </kendo-tabstrip-tab>
            }
        </kendo-tabstrip>
    }

    <!-- The reason stays at the foot of every tab, out of the way of the values. -->
    <kendo-dialog-actions layout="stretched">
        <div class="footer">
            <label class="reason">
                <span class="label">{{ "FLIGHT_LIST.edit.reason" | translate }} <span class="required">*</span></span>
                <kendo-textarea [formControl]="reason" [rows]="2" resizable="none"></kendo-textarea>
                @if (reason.invalid && reason.touched) {
                    <span class="error">{{ "FLIGHT_LIST.edit.errors.reason" | translate }}</span>
                }
            </label>
            <div class="footer-actions">
                @if (failed()) {
                    <span class="error">{{ "FLIGHT_LIST.edit.failed" | translate }}</span>
                }
                <span class="changes">{{ "FLIGHT_LIST.edit.changes" | translate: { count: changedCount() } }}</span>
                <button kendoButton (click)="closed.emit()">{{ "FLIGHT_LIST.edit.cancel" | translate }}</button>
                <button kendoButton class="save" [disabled]="!ready() || saving() || !changedCount() || form.invalid || reason.invalid" (click)="save()">
                    {{ "FLIGHT_LIST.edit.save" | translate }}
                </button>
            </div>
        </div>
    </kendo-dialog-actions>
</kendo-dialog>
